import serviceIcon from "@/assets/images/services/features/sap/service.svg";
import solutionIcon from "@/assets/images/services/features/sap/support.svg";
import supportIcon from "@/assets/images/services/features/sap/support.svg";

import sapAboutImage from "@/assets/images/services/about/sap-about-image.png";

const odooPartner = {
  "odoo-partner": {
    slug: "odoo-partner",
    name: "Odoo Partner",
    hero: {
      title: "Odoo Partner in India – GSUS Star Software solutions private limited",
      description:
        "Your Trusted ERP Implementation & Business Automation Experts GSUS Star Software is an official Odoo Partner in India, offering tailored ERP solutions for small, medium, and large businesses.Our mission is simple: help you manage, automate, and grow your business with the power of Odoo — an all-in -one business management platform."
    },

    features: [
      {
        icon: serviceIcon,
        title: "All-in-One Business Software",
        description:
          "CRM, Sales, Accounting, Inventory, HR, Manufacturing, POS, Marketing, and more."
      },
      {
        icon: solutionIcon,
        title: "100% Customizable",
        description:
          "Tailored to fit your unique workflows and industry needs."
      },
      {
        icon: supportIcon,
        title: "Affordable & Scalable",
        description:
          "Start small and grow at your own pace."
      }
    ],

    about: {
      subtitle: "Industries We Serve",
      heading: "We deliver Odoo ERP solutions for a variety of industries",
      image: sapAboutImage,
      highlights: [
        "Retail & E-Commerce",
        "Manufacturing & Supply Chain",
        "Healthcare & Life Sciences",
        "Construction & Real Estate",
        "Education & Training",
        "Small and Medium Enterprices"
      ]
    },

    // services: {
    //   title: "Transform Your Business with AI-Driven Innovation",
    //   description:
    //     "Empower your business with cutting-edge AI solutions that drive efficiency, automation, and intelligent decision-making. From data analytics to natural language processing, our technologies unlock new opportunities for growth and smarter operations.",
    //   items: [
    //     {
    //       image: dataAnalyticsImage,
    //       name: "AI-Powered Data Analytics",
    //       description:
    //         "Transform your data into actionable insights with our AI-powered analytics solutions. We help you make informed decisions that drive business growth.",
    //       features: [
    //         "Advanced data mining techniques",
    //         "Customized reporting dashboards",
    //         "Real-time data processing",
    //         "Predictive analytics for future trends"
    //       ]
    //     },
    //     {
    //       image: automationImage,
    //       name: "Intelligent Automation",
    //       description:
    //         "Boost productivity and reduce operational costs with our AI-driven automation solutions. We streamline your workflows for maximum efficiency.",
    //       features: [
    //         "Process automation for routine tasks",
    //         "Custom workflows and automation",
    //         "AI-powered decision-making tools",
    //         "Integration with existing systems"
    //       ]
    //     },
    //     {
    //       image: NLPImage,
    //       name: "Natural Language Processing (NLP)",
    //       description:
    //         "Enhance customer experiences with our NLP solutions. We enable seamless communication between humans and machines, improving user interaction and support.",
    //       features: [
    //         "Chatbot development",
    //         "Sentiment analysis",
    //         "Language translation",
    //         "Speech recognition and processing"
    //       ]
    //     }
    //   ]
    // },

    processKpi: {
      heading: "Our Odoo Implementation Process",
      steps: [
        {
          number: "01",
          title: "Business Consultation",
          description:
            "Understanding your requirements."
        },
        {
          number: "02",
          title: "Customization",
          description:
            "Modifying Odoo modules for your processes."
        },
        {
          number: "03",
          title: "Data Migration",
          description:
            "Securely moving your existing data to Odoo."
        },
        {
          number: "04",
          title: "Integration",
          description: "Connecting Odoo with other tools and software."
        },
        {
          number: "05",
          title: "Training & Go-Live",
          description:
            "Empowering your team to use Odoo effectively."
        },
        {
          number: "06",
          title: "Ongoing Support",
          description:
            "Continuous updates, troubleshooting, and enhancements."
        }
      ]
    },

    expertise: {
      heading: "Why Businesses Trust GSUS Star Software",
      business: [
        {
          description: "End-to-End Start-up Support"
        },
        {
          description: "Data-Driven Decisions"
        },
        {
          description: "Strong Community & Network"
        },
        {
          description:
            "Mentorship & Expert Access"
        },
        {
          description:
            "Branding & Marketing Support"
        }
      ]
    },
    cta: {
      title: "Get Started with Your Odoo ERP Today",
      description:
        "Transform your business with a scalable, affordable, and customizable ERP solution from GSUS Star Software. Whether you’re starting fresh or migrating from another system, we make Odoo work for you.",
      button: "Book your free consultation now!"
    },

    faq: {
      items: [
        {
          question:
            "What is Odoo ERP?",
          answer:
            "Odoo is an all-in-one business management software that includes modules for CRM, Sales, Accounting, Inventory, HR, Manufacturing, Marketing, and more. It helps businesses streamline operations, reduce manual work, and improve efficiency."
        },
        {
          question: "Why should I choose GSUS Star Software as my Odoo Partner?",
          answer:
            "As a certified Odoo Partner in India, GSUS Star Software provides end-to-end ERP services — from consultation and customization to training and ongoing support. Our local expertise ensures smooth implementation tailored to your industry.",
        },
        {
          question: "Can Odoo be customized for my business needs?",
          answer:
            "Yes! Odoo is highly customizable. Whether you run a retail shop, manufacturing unit, healthcare service, or e-commerce business, GSUS Star Software can configure Odoo modules to match your exact workflows."
        },
        {
          question: "How long does it take to implement Odoo?",
          answer:
            "Implementation time depends on your business size and requirements. A basic setup may take a few weeks, while a fully customized ERP system may take a few months. We ensure timely delivery with minimal disruption to your business."
        },
        {
          question: "Is Odoo affordable for small businesses?",
          answer:
            "Absolutely! Odoo is cost-effective and scalable. You can start with just a few modules and add more as your business grows. This makes it perfect for small and medium-sized enterprises."
        },
        {
          question: "Do you provide training and support?",
          answer:
            "Yes, we provide comprehensive training for your team to use Odoo effectively. Plus, our dedicated support team is available for troubleshooting, updates, and ongoing assistance."
        },
        {
          question: "Can Odoo integrate with other software I’m already using?",
          answer:
            "Yes. Odoo can be integrated with third-party apps and tools such as e-commerce platforms, payment gateways, shipping providers, and more. GSUS Star Software ensures seamless integration for smooth business operations."
        },
        {
          question: "How do I get started with Odoo ERP from GSUS Star Software?",
          answer:
            "You can book a free consultation with us. Our team will analyze your needs, suggest the right modules, and create a customized ERP plan for your business."
        }
      ]
    }
  }
};
export default odooPartner;
